export default {
  title: 'Gnome',
  content: ['New ability: Nimble Fingers: Your attacks ignore armor equal to your level.'],
}
